<template>
  <div
    class="owal-form-input__container"
  >
    <label>
      {{ label }}
    </label>
    <input
      :id="id"
      :type="inputType"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      @input="emit"
      @keyup.enter="emitKeyUp"
    >
  </div>
</template>

<script>
export default {
  name: 'OwalFormInput',
  props: {
    label: {
      type: String,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  methods: {
    emit ($event) {
      this.$emit('input', $event)
    },
    emitKeyUp () {
      this.$emit('enter')
    },
  },
}
</script>

<style scoped>
.owal-form-input__container {
  font-family: 'Lato-Italic';
  font-size: 1rem;
  color: #8492A6;
  letter-spacing: 0;
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
}

.owal-form-input__container input {
  background: #F0F0F0;
  border: 2px solid #E0E0E0;
  border-radius: 5px;

  font-family: 'Lato-Regular', sans-serif;
  font-size: 1.28571rem;
  color: #324057;
  letter-spacing: 0;
  padding: 0.87571rem 0.64285rem;
  margin: 0.2857142857rem .1785714286rem;
  height: 3.6rem;
  flex-grow: 1;
  text-align: center;
}

.owal-form-input__container label {
  text-align: right;
  flex-shrink: 1;
  box-sizing: border-box;
  margin: 0.2857142857rem .1785714286rem;
}
</style>
